import { Grid } from '@mui/material'
import { PropsWithChildren } from 'react'

export const LoginLayout = ({children}: PropsWithChildren) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid
            
            bgcolor={'green.50'}
            width={"100%"}
            height={"100%"}
            overflow={"hidden"}
            display={"grid"}
            gridTemplateRows={"repeat(2, min-content)"}
            justifyItems={"center"}
            paddingY={14}
        >
            {children}
        </Grid>
    )
}